export default __webpack_public_path__ + "static/media/our-technology.6ec13484.png";